import { create } from 'zustand'
import { previewProspects } from '../services/api.js'

/**
 * Store global pour la recherche de prospects.
 * La recherche continue même si l'utilisateur quitte la page.
 * Les composants se ré-abonnent à l'état quand ils reviennent.
 */
export const useProspectSearchStore = create((set, get) => ({
  loading: false,
  error: null,
  results: null,
  currentQuery: '',
  notified: true, // true = l'utilisateur a déjà vu les résultats ou il n'y en a pas

  startSearch: async (query) => {
    set({ loading: true, error: null, results: null, currentQuery: query, notified: true })
    try {
      const data = await previewProspects(query)
      set({
        loading: false,
        results: {
          prospects: data.preview || [],
          total: data.total || 0,
          requestId: data.requestId,
          availableContactIds: data.availableContactIds || [],
          query,
        },
        notified: false, // résultat à notifier
      })
    } catch (err) {
      set({
        loading: false,
        error: err?.response?.data?.message || err?.message || 'Erreur de recherche',
        results: null,
      })
    }
  },

  setResults: (results) => set({ results, loading: false, notified: true }),

  markNotified: () => set({ notified: true }),

  reset: () => set({ loading: false, error: null, results: null, currentQuery: '', notified: true }),
}))
